import { AbstractControl, ValidatorFn } from '@angular/forms';
import { debounceTime, delay, map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

export interface CheckEmailServiceInterface {
  checkEmail(value: string, selfCheck: boolean): Observable<boolean>;
}

export const minLengthArrayValidator = (minLength: number) => {
  return (c: AbstractControl) => {
    return c.value.length < minLength
      ? {minLengthArray: {valid: false}}
      : null;
  };
};

export const validatePhone = (control: AbstractControl) => {
  if (!control.value) {
    return null;
  }
  const value = `${control.value}`.replace(/\D/gi, '');
  return value.length === 11 ? null : {invalidPhone: {valid: false}};
};

export const validateDate = (control: AbstractControl) => {
  const re = /\d{2}\.\d{2}\.\d{4}/gi;
  if (!control.value || re.test(control.value)) {
    return null;
  }
  return {invalidDate: {valid: false}};
};

export const validateEmail = (authService: CheckEmailServiceInterface, selfCheck = true, ignore = []) => {
  const subject = of(null).pipe(
    delay(500)
  );
  return (control: AbstractControl) => {
    if (ignore.indexOf(control.value) > -1) {
      return of(null);
    }
    return subject.pipe(
      switchMap(() => authService.checkEmail(control.value, selfCheck).pipe(
        map(valid => valid ? null : {emailTaken: true})
      ))
    );
  };
};

export const validateUrl = (control: AbstractControl) => {
  const re = /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
  if (!control.value || re.test(control.value)) {
    return null;
  }
  return {invalidUrl: true};
};

export function fileSizeValidator(maxFileSize: number): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    if (!control.value) {
      return null;
    }
  };
}
